<script>
function parseSecondHash() {
  let splittedHash = window.location.hash.split("#");
  if (splittedHash[1].indexOf("purchase") < 0) return;
  return splittedHash[2] ? splittedHash[2] : "";
}

export default {
  translate25Context: "plan",
  components: {},
  methods: {
    reset: function () {
      history.pushState(undefined, undefined, "#/purchase");
      window.dispatchEvent(new HashChangeEvent("hashchange"));
    },
    upgrade: async function (plan) {
      this.chosenPlan = plan;
      
      await this.handler.action(plan, "load_stripe", [])

      history.pushState(undefined, undefined, "#/purchase#proceed");
      window.dispatchEvent(new HashChangeEvent("hashchange"));
    },
    proceed: function (plan) {
      history.pushState(undefined, undefined, "#/purchase#thank-you");
      window.dispatchEvent(new HashChangeEvent("hashchange"));
    },
    listenHash: function () {
      this.secondHash = parseSecondHash();
    },
  },
  props: ["component", "handler"],
  data: function () {
    return {
      chosenPlan: null,
      secondHash: parseSecondHash(),
      listener: null,
    };
  },
  computed: {},
  mounted: function () {
    window.addEventListener("hashchange", this.listenHash);
    if (this.secondHash && !this.chosenPlan) {
      this.reset();
    }
  },
  beforeDestroy: function () {
    window.removeEventListener("hashchange", this.listenHash);
  },
};
</script>

<template>
  <div class="plan-tunnel-component">
    <f-sexy-scroll>
      <plan-tunnel-choose
        v-if="secondHash == ''"
        @upgrade="upgrade($event)"
        :component="component"
        :handler="handler"
      ></plan-tunnel-choose>

      <plan-tunnel-proceed
        v-if="secondHash == 'proceed'"
        :plan="chosenPlan"
        :component="component"
        :handler="handler"
        @proceed="proceed($event)"
        @reset="reset()"
      ></plan-tunnel-proceed>

      <plan-tunnel-thank-you
        v-if="secondHash == 'thank-you'"
        :component="component"
        :handler="handler"
        @reset="reset()"
      ></plan-tunnel-thank-you>
    </f-sexy-scroll>
  </div>
</template>

<style lang="scss">
.plan-tunnel-component {
  height: 100%;
  width: 100%;
  .f-sexy-scroll {
    height: 100%;
    display: flex;
    justify-content: center;
    width: 100%;
    .f-sexy-scroll-inner {
      padding: 32px 0;
      box-sizing: content-box;
    }
  }
  .main-title {
    color: var(--white-a75);
    text-align: center;
    font-family: Lato;
    font-size: 48px;
    font-style: normal;
    font-weight: 700;
    line-height: 110%; /* 52.8px */
  }
}
</style>